import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, NgModule, Output, Renderer2, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WClickOutsideModule, WHideEmptyModule } from '@wipo/w-angular/directives';
import { FFacetModule } from '@wipo/w-angular/f-facet';
import { FFacetInfoModule } from '@wipo/w-angular/internal';
import { CreateControlAccessProvider, WOption, WOptionOrString } from '@wipo/w-angular/shared';
import { WButtonModule } from '@wipo/w-angular/w-button';
import { WInputDropdownModule } from '@wipo/w-angular/w-input-dropdown';
import { WInputTextComponent, WInputTextModule } from '@wipo/w-angular/w-input-text';
import { WInputWDropdownDirective } from './w-input-w-dropdown.directive';

@Component({
    selector: 'w-input-search',
    providers: [CreateControlAccessProvider(WInputSearchComponent)],
    templateUrl: './w-input-search.component.html',
    host: { class: 'b-input-search' },
    standalone: false
})
/*
@id w-input-search
@name w-input-search
@status release
*/
export class WInputSearchComponent extends WInputWDropdownDirective {
  @ViewChild('text') inputText!: WInputTextComponent;
  @Input() override dropdownText: string = ''; // displays text in dropdown
  @Input() override dropdownList: WOptionOrString[] = []; // displays as list in dropdown
  @Input() override dropdownSelected: WOptionOrString[] = [];
  @Output() override wDropdownClick = new EventEmitter<WOption | string>(); // click on dropdown list item

  // tslint:disable-next-line: variable-name
  constructor(protected _renderer: Renderer2, protected _elementRef: ElementRef) { super(); }
  override clickSearch() {
    super.clickSearch();
    this.wChange.emit(this.value);
  }
  }
@NgModule({
  imports: [CommonModule, FormsModule,
    FFacetModule, WClickOutsideModule,
    WButtonModule,
    WHideEmptyModule, FFacetInfoModule,
    WInputDropdownModule, WInputTextModule
  ],
  exports: [WInputSearchComponent],
  declarations: [WInputSearchComponent]
})
export class WInputSearchModule { }
